import apiClient from './apiClient';

const API_URL = '/datos-maestros/pautas-reajuste';

// Catálogo de fallos/índices de Reajuste (Datos Maestros)
export const getPautasReajuste = async (soloActivas = false) => {
    const params = soloActivas ? { soloActivas: true } : {};
    const response = await apiClient.get(API_URL, { params });
    return response.data;
};

export const crearPautaReajuste = async (dto) => {
    const response = await apiClient.post(API_URL, dto);
    return response.data;
};

export const actualizarPautaReajuste = async (id, dto) => {
    const response = await apiClient.put(`${API_URL}/${id}`, dto);
    return response.data;
};

export const eliminarPautaReajuste = async (id) => {
    const response = await apiClient.delete(`${API_URL}/${id}`);
    return response.data;
};

const pautaReajusteService = {
    getPautasReajuste,
    crearPautaReajuste,
    actualizarPautaReajuste,
    eliminarPautaReajuste,
};

export default pautaReajusteService;
